<template>
  <div id="sifarma-management">
    <Breadcrumbs
      :breadcrumbs="[
      { title: this.$t('menu.configurations'), disabled: true },
      { title: this.$t('menu.sifarma-management'), disabled: true}
    ]">
    </Breadcrumbs>



    <div v-if="!isFromEvollu">
      <div style="width: 100%; height: 50px; background-color: #faeed6; border-radius: 20px; text-align: center; align-content: center">
        <span>{{$t('users.permissions.no')}}</span>
      </div>
    </div>
    <div v-else>
      <div class="row evollu-form">
        <div class="col-12 col-md-4">
          <div>
            <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
            <multiselect
              v-model="filters.entity"
              :options="allowedEntities"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('facility.inputs.entity')"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="allowedEntities.length === 1">
              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entity"
                      @mousedown.prevent.stop="filters.entity = null"></span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div>
            <label class="form-label">{{$t('agenda.inputs.facility')}}:</label>
            <multiselect
              v-model="filters.facility"
              :options="facilitiesOptions"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('agenda.inputs.facility')"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="facilitiesOptions.length === 1 || filters.entity === null">
              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.facility"
                      @mousedown.prevent.stop="filters.facility = null"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div v-if="isLoading">
        <loading-placeholder/>
      </div>
      <div v-else>
        <div v-if="permissionsData.length > 0" class="mt-2">
          <v-client-table
            id="sifarmaPermissionsTable"
            ref="sifarmaPermissionsTable"
            name="sifarmaPermissionsTable"
            :columns="columns"
            :data="permissionsData"
            :options="permissionsTableOptions"
          >
            <div slot="user" slot-scope="{row}">
              {{ row.user ? row.user.name : `ID: ${row.user_id}`}}
            </div>

            <div slot="status" slot-scope="{row}" style="padding-top: 5%">
              <i class="fa fa-circle-check" v-if="row.synced === true" style="color: #7dca52"></i>
              <i class="fa fa-circle-xmark" v-else style="color: #e57061"></i>
            </div>

            <div slot="actions" slot-scope="{row}" style="padding-top: 5%">
              <va-popover
                :message="$t('agenda.appointments.delete')"
                placement="top"
                class="clickable"
              >
                <i class="fa fa-trash-o" style="color: #730101" @click="deletePermission(row)"></i>
              </va-popover>
            </div>

          </v-client-table>
        </div>
        <div v-if="filters.entity && filters.facility">
          <div class="row col-12 evollu-form mt-3">
            <div class="col-4 pt-2">
              <multiselect
                v-model="elemToAdd.user"
                :options="availableUsers"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                :placeholder="$t('entities.roles.header_name')"
                :allow-empty="false"
                :multiple="false"
                :searchable="true">
              </multiselect>
            </div>
            <div class="col-3 pt-2">
              <va-input
                v-model="elemToAdd.sifarma_operator_code"
                type="text"
                :placeholder="$t('sifarma_management.operator_code')"
              />
            </div>
            <div class="col-3 pt-2">
              <va-input
                v-model="elemToAdd.sifarma_pharmacy_code"
                type="text"
                :placeholder="$t('sifarma_management.pharmacy_code')"
              />
            </div>
            <div class="col-2">
              <va-button
                class="clickable"
                :disabled="elemToAdd.user === null || elemToAdd.sifarma_operator_code === null || elemToAdd.sifarma_pharmacy_code === null"
                @click="handleAddElemToList"
              >
                {{ $t('entities.add') }}
              </va-button>
            </div>
          </div>
          <div class="row col-12 evollu-form mt-3 justify--end" v-if="!changesDetected">
            <va-button @click="handleSubmit" :disabled="isLoading">
              {{$t('agenda.availability.save')}} &ensp; <i class="fa fa-save" style="padding-top: 2px"/>
            </va-button>
          </div>
        </div>
      </div>


    </div>

  </div>

</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { AuthEvohealthService, AuthSifarmaService, UserService } from '@/api/AuthService';
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';
import { ClientTable } from 'vue-tables-2'
import Vue from 'vue';
Vue.use(ClientTable, {}, false, 'bootstrap4')
import { cloneDeep, isEqual } from 'lodash';

export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: { LoadingPlaceholder, Multiselect, Breadcrumbs, ClientTable },
  mixins: [IsFromEvolluMixin, MultiselectLabelFormatter],
  data: function() {
    return {
      filters: {
        entity: null,
        facility: null
      },
      elemToAdd: {
        user: null,
        user_id: null,
        sifarma_operator_code: null,
        sifarma_pharmacy_code: null,
        synced: false
      },
      facilitiesOptions: [],
      originalPermissionsData: [],
      permissionsData: [],
      isLoading: false,
      columns: ['user', 'sifarma_operator_code', 'sifarma_pharmacy_code', 'status', 'actions'],
      permissionsTableOptions:{
        sortable: [],
        filterable: false,
        headings: {
          sifarma_operator_code: this.$t('sifarma_management.operator_code'),
          sifarma_pharmacy_code: this.$t('sifarma_management.pharmacy_code'),
          user: this.$t('entities.roles.header_name'),
          status: this.$t('entities.activities.status'),
          actions: this.$t('clusters.labels.actions')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        perPage: 15,
        perPageValues: [15, 20, 30, 50, 100],
        pagination: {
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          user: 'text-center',
          sifarma_operator_code: 'text-center',
          sifarma_pharmacy_code: 'text-center',
          status: 'text-center',
          actions: 'text-center'
        }
      },
      users: [],
      availableUsers: []
    }
  },
  methods: {
    handleSubmit: async function() {
      this.isLoading = true
      try {
        const bodyData = this.permissionsData
        bodyData.forEach(elem => delete elem.user)
        let data = await AuthSifarmaService.submitPermissions(this.filters.facility.id, bodyData)
        if(data && data.length) {
          data.forEach(elem => {
            elem.synced = true
            elem.user = this.users.find(user => user.id === elem.user_id) || null
            if(elem.user) {
              this.availableUsers = this.availableUsers.filter(user => user.id !== elem.user.id)
            }
          })
          this.permissionsData = data
          this.originalPermissionsData = cloneDeep(data)
        }
      } catch (e) {
        console.log("ERROR: ")
        console.log(e)
      } finally {
        this.isLoading = false
      }

    },
    getUsersOfEntity: async function(entity) {
      try {
        const data = await UserService.getByEntity(entity.id)
        if(data && data.length) {
          this.users = data
          this.availableUsers = this.users
        }
      } catch(e) {
        console.log("Error getting users")
        console.log(e)
        this.showToast(this.$t('profile.notifications.something_went_wrong'), this.$store.state.errorToastOptions)
        this.isLoading = false
      } finally {

      }
    },
    getPermissionsForFacility: async function(facility) {
      try {
        const data = await AuthSifarmaService.getSifarmaPermissionsDataByFacility(facility.id)
        if(data && data.length) {
          data.forEach(elem => {
            elem.synced = true
            elem.user = this.users.find(user => user.id === elem.user_id) || null
            if(elem.user) {
              this.availableUsers = this.availableUsers.filter(user => user.id !== elem.user.id)
            }
          })
          this.permissionsData = data
          this.originalPermissionsData = cloneDeep(data)
        } else {
          this.permissionsData = []
          this.originalPermissionsData = []
        }
      } catch(e) {
        console.log("Error getting permissions")
        console.log(e)
        this.showToast(this.$t('profile.notifications.something_went_wrong'), this.$store.state.errorToastOptions)
        this.isLoading = false
      }
    },
    handleAddElemToList: function() {
      this.permissionsData.push({
        ...this.elemToAdd,
        user_id: this.elemToAdd.user.id,
      })

      //Remove the user from available users
      this.availableUsers = this.availableUsers.filter(elem => elem.id !== this.elemToAdd.user.id)

      this.elemToAdd = {
        user: null,
        user_id: null,
        sifarma_operator_code: null,
        sifarma_pharmacy_code: this.filters.facility.facility_code !== null && this.filters.facility.facility_code.trim() !== '' ? this.filters.facility.facility_code.trim() : null,
        synced: false
      }


    },
    deletePermission: function(row) {
      // Remove the row from permissionsData
      const match = this.permissionsData.find(item =>
        item.user_id === row.user_id &&
        item.sifarma_operator_code === row.sifarma_operator_code &&
        item.sifarma_pharmacy_code === row.sifarma_pharmacy_code &&
        item.synced === row.synced
      );
      const index = this.permissionsData.indexOf(match);
      if(index!==-1) {
        this.permissionsData.splice(index, 1)
      }
      // Add the user back to availableUsers if it's not there already
      let userIndex = this.availableUsers.findIndex(elem => elem.id === row.user_id)
      if(userIndex === -1) {
        this.availableUsers.push(this.users.find(user => user.id === row.user_id))
        this.availableUsers.sort((a, b) => a.name.localeCompare(b.name))
      }

    }
  },
  computed: {
    allowedEntities: function() {
      const permissions = this.component.service.user_permissions.filter(elem => elem.info_type === 320)
      let entities = []
      if(permissions.some(perm => perm.entity_id === null)) {
        entities = this.component.service.entities
      } else {
        const entitiesIdsArr = permissions.map(perm => perm.entity_id)
        entities = this.component.service.entities.filter(ent => entitiesIdsArr.includes(ent.id))
      }
      return entities
    },
    changesDetected: function () {
      const simplify = (arr) =>
        arr.map(p => ({
          user_id: p.user_id,
          sifarma_operator_code: p.sifarma_operator_code,
          sifarma_pharmacy_code: p.sifarma_pharmacy_code,
          synced: p.synced
        }));

      return isEqual(simplify(this.originalPermissionsData), simplify(this.permissionsData));
    }
  },
  watch: {
    'filters.entity': async function(val) {
      if(val !== null) {
        this.isLoading = true
        this.facilitiesOptions = val.facilities
        this.filters.facility = null
        if(this.facilitiesOptions.length===1) {
          this.filters.facility = this.facilitiesOptions[0]
        }
        await this.getUsersOfEntity(val)
        this.isLoading = false
      } else {
        this.facilitiesOptions = []
        this.filters.facility = null
        this.permissionsData = []
        this.elemToAdd.sifarma_pharmacy_code = null
      }
    },
    'filters.facility': async function(facility) {
      if(facility) {
        this.isLoading = true
        await this.getPermissionsForFacility(facility)
        if(facility.facility_code !== null && facility.facility_code.trim() !== '') {
          this.elemToAdd.sifarma_pharmacy_code = facility.facility_code.trim()
        }
        this.isLoading = false
      } else {
        this.permissionsData = []
        this.elemToAdd.sifarma_pharmacy_code = null
      }
    }
  }
};
</script>

<style scoped lang="scss">
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

::v-deep(.table-responsive) {
  overflow: visible !important;
}

::v-deep(.VueTables__table) {
  overflow: visible !important;
}

.center-text {
  text-align: center;
}
</style>
